<template>
  <vx-tooltip :text="$t('cancel')" position="bottom">
    <vs-button class="text-center cancelButton" color="warning" type="filled" icon-pack="feather" icon="icon-x" size="small" @click.prevent="click"></vs-button>
  </vx-tooltip>
</template>

<script>
export default {
  name: 'CancelButton',
  methods: {
    click () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>

</style>
